// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage, defineMessages } from "react-intl";

export const Intro = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.intro"
        description="Intro."
        defaultMessage="Top Performer awards are one-time payouts for Lenses that break out in their first 90 days. It's a separate program from Lens+."
    />
);
Intro.displayName = "Intro";

export const HowPayoutsWork = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.howPayoutsWork"
        description="How payouts work."
        defaultMessage="How payouts work"
    />
);
HowPayoutsWork.displayName = "HowPayoutsWork";

export const StepReachTitle = (props: { threshold: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.stepReachTitle"
        description="Step reach title."
        defaultMessage="Reach {threshold} qualified posters"
        values={props}
    />
);
StepReachTitle.displayName = "StepReachTitle";

export const StepReachBody = (props: { threshold: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.stepReachBody"
        description="Step reach body."
        defaultMessage="Your Lens has to hit {threshold} qualified posters within its first 90 days to be considered."
        values={props}
    />
);
StepReachBody.displayName = "StepReachBody";

export const StepReachTitleNoThreshold = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.stepReachTitleNoThreshold"
        description="Step reach title no threshold."
        defaultMessage="Reach the qualified poster goal"
    />
);
StepReachTitleNoThreshold.displayName = "StepReachTitleNoThreshold";

export const StepReachBodyNoThreshold = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.stepReachBodyNoThreshold"
        description="Step reach body no threshold."
        defaultMessage="Your Lens has to hit the qualified poster goal within its first 90 days to be considered."
    />
);
StepReachBodyNoThreshold.displayName = "StepReachBodyNoThreshold";

export const StepCriteriaTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.stepCriteriaTitle"
        description="Step criteria title."
        defaultMessage="Meet the eligibility criteria"
    />
);
StepCriteriaTitle.displayName = "StepCriteriaTitle";

export const StepCriteriaBody = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.stepCriteriaBody"
        description="Step criteria body."
        defaultMessage="Additional account, country, and performance requirements apply."
    />
);
StepCriteriaBody.displayName = "StepCriteriaBody";

export const SeeFullCriteria = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.seeFullCriteria"
        description="See full criteria."
        defaultMessage="See full criteria"
    />
);
SeeFullCriteria.displayName = "SeeFullCriteria";

export const StepPaidTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.stepPaidTitle"
        description="Step paid title."
        defaultMessage="Paid the following month"
    />
);
StepPaidTitle.displayName = "StepPaidTitle";

export const StepPaidBody = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.stepPaidBody"
        description="Step paid body."
        defaultMessage="Selected Lenses get a one-time award in the next monthly pay cycle. Awards don't repeat."
    />
);
StepPaidBody.displayName = "StepPaidBody";

export const HistoryTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.historyTitle"
        description="History title."
        defaultMessage="Payout history"
    />
);
HistoryTitle.displayName = "HistoryTitle";

export const HistorySubtitle = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.historySubtitle"
        description="History subtitle."
        defaultMessage="One-time awards by month"
    />
);
HistorySubtitle.displayName = "HistorySubtitle";

export const TotalAllTime = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.totalAllTime"
        description="Total all time."
        defaultMessage="Total, all time"
    />
);
TotalAllTime.displayName = "TotalAllTime";

export const RangeLast6Months = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.rangeLast6Months"
        description="Range last6 months."
        defaultMessage="Last 6 months"
    />
);
RangeLast6Months.displayName = "RangeLast6Months";

export const RangeLast12Months = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.rangeLast12Months"
        description="Range last12 months."
        defaultMessage="Last 12 months"
    />
);
RangeLast12Months.displayName = "RangeLast12Months";

export const LegendAwarded = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.legendAwarded"
        description="Legend awarded."
        defaultMessage="Awarded"
    />
);
LegendAwarded.displayName = "LegendAwarded";

export const LegendInProgress = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.legendInProgress"
        description="Legend in progress."
        defaultMessage="In progress"
    />
);
LegendInProgress.displayName = "LegendInProgress";

export const HistoryFootnote = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.historyFootnote"
        description="History footnote."
        defaultMessage="Each bar is a monthly pay cycle. Most months have no award. Top Performer payouts happen only when a Lens is selected."
    />
);
HistoryFootnote.displayName = "HistoryFootnote";

export const AwardDetailLine = (props: { lens: ReactNode; amount: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.awardDetailLine"
        description="Award detail line."
        defaultMessage="{lens} · {amount}"
        values={props}
    />
);
AwardDetailLine.displayName = "AwardDetailLine";

export const NoAwardThisMonth = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.noAwardThisMonth"
        description="No award this month."
        defaultMessage="No award this month"
    />
);
NoAwardThisMonth.displayName = "NoAwardThisMonth";

export const SelectionsInProgress = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.selectionsInProgress"
        description="Selections in progress."
        defaultMessage="Selections in progress"
    />
);
SelectionsInProgress.displayName = "SelectionsInProgress";

export const Pending = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.pending"
        description="Pending."
        defaultMessage="Pending"
    />
);
Pending.displayName = "Pending";

export const HistoryError = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.historyError"
        description="History error."
        defaultMessage="Unable to load payout history. Please try again."
    />
);
HistoryError.displayName = "HistoryError";

export const LensesTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.lensesTitle"
        description="Lenses title."
        defaultMessage="Your Top Performer Lenses"
    />
);
LensesTitle.displayName = "LensesTitle";

export const UpdatedDaily = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.updatedDaily"
        description="Updated daily."
        defaultMessage="Updated daily"
    />
);
UpdatedDaily.displayName = "UpdatedDaily";

export const LensesSubtitle = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.lensesSubtitle"
        description="Lenses subtitle."
        defaultMessage="All your enrolled Lenses and where they stand."
    />
);
LensesSubtitle.displayName = "LensesSubtitle";

export const TileEnrolled = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.tileEnrolled"
        description="Tile enrolled."
        defaultMessage="Enrolled Lenses"
    />
);
TileEnrolled.displayName = "TileEnrolled";

export const TileEnrolledHint = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.tileEnrolledHint"
        description="Tile enrolled hint."
        defaultMessage="Including closed windows"
    />
);
TileEnrolledHint.displayName = "TileEnrolledHint";

export const TileAwarded = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.tileAwarded"
        description="Tile awarded."
        defaultMessage="Awarded to date"
    />
);
TileAwarded.displayName = "TileAwarded";

export const TileAwardedHint = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.tileAwardedHint"
        description="Tile awarded hint."
        defaultMessage="Lenses that received a payout"
    />
);
TileAwardedHint.displayName = "TileAwardedHint";

export const TileTotalEarned = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.tileTotalEarned"
        description="Tile total earned."
        defaultMessage="Total earned"
    />
);
TileTotalEarned.displayName = "TileTotalEarned";

export const TileTotalEarnedHint = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.tileTotalEarnedHint"
        description="Tile total earned hint."
        defaultMessage="All one-time awards"
    />
);
TileTotalEarnedHint.displayName = "TileTotalEarnedHint";

export const ColumnIcon = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.columnIcon"
        description="Column icon."
        defaultMessage="Icon"
    />
);
ColumnIcon.displayName = "ColumnIcon";

export const ColumnName = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.columnName"
        description="Column name."
        defaultMessage="Name"
    />
);
ColumnName.displayName = "ColumnName";

export const ColumnPosters = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.columnPosters"
        description="Column posters."
        defaultMessage="Qualified posters"
    />
);
ColumnPosters.displayName = "ColumnPosters";

export const ColumnStatus = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.columnStatus"
        description="Column status."
        defaultMessage="Status"
    />
);
ColumnStatus.displayName = "ColumnStatus";

export const ColumnAward = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.columnAward"
        description="Column award."
        defaultMessage="Award"
    />
);
ColumnAward.displayName = "ColumnAward";

export const PostersProgress = (props: { qualified: ReactNode; threshold: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.postersProgress"
        description="Posters progress."
        defaultMessage="{qualified} / {threshold}"
        values={props}
    />
);
PostersProgress.displayName = "PostersProgress";

export const PostersCount = (props: { qualified: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.postersCount"
        description="Posters count."
        defaultMessage="{qualified} posters"
        values={props}
    />
);
PostersCount.displayName = "PostersCount";

export const StatusAwarded = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.statusAwarded"
        description="Status awarded."
        defaultMessage="Awarded"
    />
);
StatusAwarded.displayName = "StatusAwarded";

export const StatusUnderReview = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.statusUnderReview"
        description="Status under review."
        defaultMessage="Under review"
    />
);
StatusUnderReview.displayName = "StatusUnderReview";

export const StatusInWindow = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.statusInWindow"
        description="Status in window."
        defaultMessage="In 90-day window"
    />
);
StatusInWindow.displayName = "StatusInWindow";

export const StatusDidNotQualify = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.statusDidNotQualify"
        description="Status did not qualify."
        defaultMessage="Didn't qualify"
    />
);
StatusDidNotQualify.displayName = "StatusDidNotQualify";

export const StatusUnknown = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.statusUnknown"
        description="Status unknown."
        defaultMessage="Status unavailable"
    />
);
StatusUnknown.displayName = "StatusUnknown";

export const NoAward = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.noAward"
        description="No award."
        defaultMessage="-"
    />
);
NoAward.displayName = "NoAward";

export const NoLenses = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.noLenses"
        description="No lenses."
        defaultMessage="None of your Lenses are enrolled in Top Performer yet."
    />
);
NoLenses.displayName = "NoLenses";

export const LensesError = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.lensesError"
        description="Lenses error."
        defaultMessage="Unable to load your Top Performer Lenses. Please try again."
    />
);
LensesError.displayName = "LensesError";

export const PostersUnavailable = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.postersUnavailable"
        description="Posters unavailable."
        defaultMessage="Unavailable"
    />
);
PostersUnavailable.displayName = "PostersUnavailable";

export const RangeLifetime = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.rangeLifetime"
        description="Range lifetime."
        defaultMessage="Lifetime"
    />
);
RangeLifetime.displayName = "RangeLifetime";

export const TotalSelectedRange = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.topPerformer.totalSelectedRange"
        description="Total selected range."
        defaultMessage="Total, selected range"
    />
);
TotalSelectedRange.displayName = "TotalSelectedRange";

export const messages = defineMessages({
    postersProgressLabel: {
        id: "apps.monetization.components.topPerformer.postersProgressLabel",
        description: "Posters progress label.",
        defaultMessage: "Progress toward the qualified poster goal",
    },
});
